import { Plus } from 'lucide-react';
import { SubmitButton } from '@/components/ui/Button';

interface TableAddButtonProps {
  onClick: () => void;
  label?: string;
}

export default function TableAddButton({ onClick, label }: Readonly<TableAddButtonProps>) {
  return (
    <div className="flex justify-end px-5 pb-6">
      <SubmitButton type="button" onClick={onClick} data-testid="table-add-button" className="flex items-center gap-1">
        <Plus size={16} />
        {label ?? 'Tambah'}
      </SubmitButton>
    </div>
  );
}
